import { lazy } from "react";
const notFound = lazy(() => import("@/pages/notFound"));
const BaseLayout = lazy(() => import("@/components/layout/baseLayout"));

export default {
    path: "/notFound",
    component: notFound,
    layout: BaseLayout,
}
